import { render } from "./CampoEmail.vue?vue&type=template&id=ad9deaf0&ts=true"
import script from "./CampoEmail.vue?vue&type=script&lang=ts"
export * from "./CampoEmail.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__